const { populate } = require('@/functions/objects');

class LoginSettings {
    constructor(data = {}) {
        /**
         * Show the Entra ID login button on the login page?
         * This setting only applies if entraIDLoginEnabled is `null` in the configuration file.
         *
         * @type {boolean}
         */
        this.showEntraID = false;

        populate(this, data);
    }
}

module.exports = LoginSettings;
